
import { MenuItem } from "@mui/material";
import { blackoutHours } from "./AlarmScheduleEditorUtils";
import { FormFieldPropsBase } from "../../../components/forms/form/Form";
import FormSelect from "../../../components/forms/form-select/FormSelect";

export type BlackoutHourOptionsProps = FormFieldPropsBase & {
    onChange?: () => void;
    rules?: any
};

export default function BlackoutHourOptions({
    label,
    name,
    disabled,
    onChange,
    rules
}: BlackoutHourOptionsProps) { 


    return (
        <FormSelect
            name={name}
            label={label}
            disabled={disabled}
            sx={{
                flexBasis: '50%',
                marginRight: 1
            }}
            rules={rules}
            onChange={() => {onChange && onChange()}}
        >
        {
        blackoutHours.map((value, index) =>
            <MenuItem key={index} value={value}>
                {value}
            </MenuItem>)
        }
    </FormSelect>

    );
}

